export default {"src":"/_next/static/media/clock-4-700.f75d4652.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};